import { FC, useCallback, useState } from 'react'
import { DataGrid, GridPaginationModel } from '@mui/x-data-grid'
import { useNavigate } from 'react-router'
import styles from './styles.module.scss'
import { Box } from '@mui/material'
import { dashboards } from '../AdssDashboard'

const initialPaginationModel = {
  page: 0,
  pageSize: 20,
}

interface IProps {}

const DashboardList: FC<IProps> = () => {
  const navigate = useNavigate()

  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>(initialPaginationModel)
  const total = dashboards.length

  const isLoading = false

  const handleNavigate = useCallback(
    (id: number) => {
      navigate(`/dashboard/${id}`)
    },
    [navigate],
  )

  return (
    <Box className={styles.container}>
      <DataGrid
        loading={isLoading}
        rowSelection={false}
        //onRowClick={(e) => onSelectDashboard.apply(null, [e.row.id])}
        onRowClick={(e) => handleNavigate(e.row.id)}
        columns={[
          {
            field: 'id',
            headerName: 'ID',
            width: 70,
            sortable: false,
            filterable: false,
          },
          {
            field: 'name',
            headerName: 'Name',
            flex: 1.5,
            sortable: false,
            filterable: false,
          },
        ]}
        rows={dashboards}
        rowCount={total}
        pagination
        paginationMode="server"
        paginationModel={paginationModel}
        pageSizeOptions={[20, 50, 100]}
        onPaginationModelChange={setPaginationModel}
        sx={{
          '& div.MuiDataGrid-row': {
            cursor: 'pointer',
          },
        }}
      />
    </Box>
  )
}

export default DashboardList
